export const FAKE_STRING = 'fake_string_for_reload';

export const LOADING_STRING = '...';
